import { Root } from './Root';
import { Header } from './Header';
import { Body } from './Body';
import { Footer } from './Footer';
import { SelectAll } from './SelectAll';
import { SelectedList } from './SelectedList';
import { useUserSelector } from './helpers';

export const UserSelectorDialog = {
  Root,
  Header,
  Body,
  Footer,
  SelectAll,
  SelectedList,
  useUserSelector,
} as const;
